import { compact, filterKeys } from "web/services/helpers"

export function getFieldFromFormValue({ formValue }) {
  const fieldFields = [
    "name",
    "kind",
    "label",
    "description",
    "expression",
    "default_expression",
    "show_expression",
    "multiple_values",
    "convert_for_display",
    "prioritize_default_expression",
    "basis_kind",
    "summary_method",
    "weight_field_id",
    "display_unit_code",
  ]

  const nullable = {
    description: null,
    expression: null,
    default_expression: null,
    show_expression: null,
    summary_method: null,
    basis_kind: null,
  }

  return {
    ...nullable,
    ...compact(filterKeys(formValue, fieldFields)),
    format:
      formValue.numberFormat ||
      formValue.dateFormat ||
      formValue.numericalFormat ||
      null,
  }
}

function getAvailableKinds(field) {
  const isNew = field.id === undefined

  if (!isNew && (field.kind === "Text" || field.kind === "RichText")) {
    return [
      { value: "RichText", label: "Rich Text" },
      { value: "Text", label: "Text" },
    ]
  } else {
    return [
      { value: "Area", label: "Area" },
      { value: "Boolean", label: "True/False" },
      { value: "Date", label: "Date" },
      { value: "Distance", label: "Distance" },
      { value: "Length", label: "Length" },
      { value: "Lookup", label: "Lookup" },
      { value: "Money", label: "Money" },
      { value: "Number", label: "Number" },
      { value: "RichText", label: "Rich Text" },
      { value: "Size", label: "Size" },
      { value: "Text", label: "Text" },
      { value: "Contact", label: "Contact" },
      { value: "InternalContact", label: "Internal Contact" },
      { value: "Company", label: "Company" },
      { value: "Portfolio", label: "Portfolio" },
      { value: "User", label: "User" },
    ]
  }
}

export function getKindField(field) {
  const isSingleValueTextField = field.kind === "Text" && !field.multiple_values
  const isEditableKind = isSingleValueTextField || field.kind === "RichText"
  const isCustomField = field.customization_level === "custom"

  const canUpdateFieldKind = isCustomField && isEditableKind

  return {
    key: "kind",
    name: "kind",
    kind: "Lookup",
    label: "Type",
    lookup_values: getAvailableKinds(field),
    required: true,
    description: "Type of information stored in the field.",
    mutable: canUpdateFieldKind,
  }
}
